import { useCallback } from 'react';
import { useRouteRef } from '@backstage/core-plugin-api';
import { useNavigate } from 'react-router-dom';
import {
  activityConnectRouteRef,
  activityMetricsRouteRef,
  controlPlaneCockpitRouteRef,
  controlPlaneActivityNewRouteRef,
} from '../../routes';
import type { Activity } from '../../api/types';
import { normalizeRouteRefPath } from '../../utils/routes';

export function usePortfolioRoutes(onCreate?: () => void) {
  const activityConnectRoute = useRouteRef(activityConnectRouteRef);
  const activityMetricsRoute = useRouteRef(activityMetricsRouteRef);
  const controlPlaneCockpitRoute = useRouteRef(controlPlaneCockpitRouteRef);
  const createRoute = useRouteRef(controlPlaneActivityNewRouteRef);
  const navigate = useNavigate();
  const getPrimaryActivityRoute = useCallback(
    // /connect decides between the Control Plane redirect and the notice for
    // a retired work path.
    (activity: Activity) =>
      normalizeRouteRefPath(activityConnectRoute({ activityId: activity.id })),
    [activityConnectRoute],
  );

  const getActivityCockpitRoute = useCallback(
    (activity: Activity) => {
      if (activity.workPath === 'control-plane' && controlPlaneCockpitRoute) {
        return normalizeRouteRefPath(
          controlPlaneCockpitRoute({ activityId: activity.id }),
        );
      }
      return normalizeRouteRefPath(
        activityMetricsRoute({ activityId: activity.id }),
      );
    },
    [activityMetricsRoute, controlPlaneCockpitRoute],
  );

  const openCreation =
    onCreate ?? (() => navigate(normalizeRouteRefPath(createRoute())));
  return { getPrimaryActivityRoute, getActivityCockpitRoute, openCreation };
}
export type PortfolioRoutes = ReturnType<typeof usePortfolioRoutes>;
